import { baseApi } from "../baseApi";

export const asnApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Existing supplier PO fetcher
    getSupplierPos: builder.mutation({
      query: (supplier) => ({
        url: '/api/method/stackerbee_mobile_wms.stackerbee_mobile_wms.doctype.advance_shipment_note.advance_shipment_note.get_supplier_pos',
        method: 'POST',
        body: { supplier },
      }),
    }),

    // ✅ New: Fetch PO Items for ASN
    getPOItemsForASN: builder.mutation({
      query: (purchase_orders) => ({
        url: '/api/method/stackerbee_mobile_wms.stackerbee_mobile_wms.doctype.advance_shipment_note.advance_shipment_note.get_po_items_for_asn',
        method: 'POST',
        body: { purchase_orders },
      }),
    }),
        createASN: builder.mutation({
      query: (asnData) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.create_asn',
        method: 'POST',
        body: asnData,
      }),
    }),

     submitASN: builder.mutation({
      query: (asnPayload) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.submit_asn',
        method: 'POST',
        body: asnPayload,
      }),
      invalidatesTags: ['ASN']
    }),
        updateASN: builder.mutation({
      query: (asnPayload) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.update_asn',
        method: 'POST',
        body: asnPayload,
      }),
    }),
    getASNDetails: builder.query({
      query: (asnId) => `/api/resource/Advance Shipment Note/${asnId}`,
    }),
getASNList: builder.mutation({
      query: (filters) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.get_asn_list',
        method: 'POST',
        body: filters,
      }),
      providesTags: ['ASN']
    }),

        getAllPurchaseOrdersForASN: builder.query({
      query: () => ({
        url: '/api/method/stackerbee_mobile_wms.stackerbee_mobile_wms.doctype.advance_shipment_note.advance_shipment_note.get_all_purchase_orders_for_asn',
        method: 'GET',
      }),
    }),

  }),
});

export const {
  useGetSupplierPosMutation,
  useGetPOItemsForASNMutation,
  useCreateASNMutation,
  useSubmitASNMutation,
  useUpdateASNMutation,
  useGetASNDetailsQuery,
  useGetASNListMutation,
  useGetAllPurchaseOrdersForASNQuery
} = asnApi;
